export const en = {
    newUser: {
        continueBtn: 'Continue',
        h1: 'Welcome to Funki!',
        h2: 'To make your experience as good as possible, start by choosing your settings.'
    },
    admin: {
        customersRouteBtn: 'Customers',
        soundbankSoundsRouteBtn: 'Soundbank and Songs',
        usersRouteBtn: 'Users',

        customersTable: {
            alerts: {
                removeSuccess: 'Removed',
                removeError: 'Failed to remove',
                addSuccess: 'Added',
                updateSuccess: 'Updated',
                updateError: 'Failed to update customer. Error message'
            },

            mainHeading: 'Customers',
            paymentPlanHeaderName: 'Payment Plan',
            paymentMethodHeaderName: 'Payment Method',
            licenseStartHeaderName: 'License Start',
            licenseExpireHeaderName: 'License Expiration',
            instrumentsHeaderName: 'Instruments',
            soundpackagesHeaderName: 'Song Packages',
            actionsHeaderName: 'Actions',
            idHeaderName: 'ID',
            aliasHeaderName: 'Alias',
            contactEmailHeaderName: 'Contact Email',

            gridActionCopyActivationCode: 'Copy Activation Code',
            gridActionSave: 'Save',
            gridActionCancel: 'Cancel',
            gridActionEditSongPackage: 'Edit Song Package',
            gridActionDelete: 'Delete',
            gridActionEdit: 'Edit',
            gridActionEditInstrument: 'Edit Instrument'
        },

        customersToolbar: {
            openDialogHeading: 'Handling failures',
            openDialogText: 'Failed to create new customer as a new customer ID could not be generated from the database.',
            closeDialogBtn: 'Okay'
        },

        editInstrumentsDialog: {
            heading: 'Edit instruments for',
            form: {
                deviceIdLabel: 'Device ID',
                instrumentType: 'Type',
                submitBtn: 'Add instrument'
            },
            removeBtn: 'Remove',
            saveBtn: 'Save',
            cancelBtn: 'Cancel'
        },

        editPackage: {
            heading: 'Edit song package',
            form: {
                submitBtn: 'Add song package'
            },
            packageNameText: 'Package name',
            removeBtn: 'Remove',
            saveBtn: 'Save',
            cancelBtn: 'Cancel'
        },

        editSongPackageDialog: {
            heading: 'Edit song package for',
            form: {
                submitBtn: 'Add song package'
            },
            packageNameLabel: 'Package name',
            removeBtn: 'Remove',
            saveBtn: 'Save',
            cancelBtn: 'Cancel'
        },

        songsAndSoundsTable: {
            heading: 'Songs and sounds',

            IdHeader: 'Id',
            TitleHeader: 'Title',
            ImageHeader: 'Image',
            DescriptionHeader: 'Description',
            TypeHeader: 'Type',
            SongPackageHeader: 'Song Package',
            CategoryHeader: 'Category',
            ArtistHeader: 'Artist',
            GenreHeader: 'Genre',
            KeyHeader: 'Key',
            TempoHeader: 'Tempo',
            SectionsHeader: 'Sections',
            BackingTrackHeader: 'Backing Track',
            ActionsHeader: 'Actions',

            gridActionSave: 'Save',
            gridActionSongPackage: 'Package',
            gridActionCancel: 'Cancel',
            gridActionDelete: 'Delete',
            gridActionEdit: 'Edit',
            gridActionAddImage: 'Add image'
        },

        songsAndSoundsToolbar: {
            failedAction: 'Action failed',
            failedPostCreation: 'Failed to create new song post as a new song ID could not be generated from the database.',

            addSongBtn: 'Add song',
            closeDialogBtn: 'Okay'
        },

        userInfoDialog: {
            heading: 'Info - Extended user management',
            infoText: 'Currently, actions such as deleting user accounts, changing email, etc., cannot be performed from this admin interface. Such actions can only be performed in the Firebase console:',
            closeDialogBtn: 'Okay'
        },

        usersTable: {
            alerts: {
                success: 'Updated users',
                error: 'Failed to update users. Error message:'
            },
            iDHeader: 'Id',
            nameHeader: 'Name',
            emailHeader: 'Email',
            connectedCustomerId: 'Linked customer license',
            customerAliasHeader: 'Customer alias',
            createdHeader: 'Created',
            lastSignedInHeader: 'Last signed in',
            adminHeader: 'Admin',
            actionsHeader: 'Actions',
            gridActionSave: 'Save',
            gridActionCancel: 'Cancel',
            gridActionEdit: 'Edit',
            gridActionInfo: 'Info',
            usersHeading: 'Users'
        }
    },

    components: {
        navbar: {
            logoutBtn: 'Log out',
            homeRouteBtn: 'Home',
            libraryRouteBtn: 'Library'
        },
        header: {
            activateAccountRouteBtn: 'Activate Account',
            loginRouteBtn: 'Log in',
            headingSettings: 'Settings'
        },
        currentlyPlaying: {
            textGenre: 'Genre',
            textKey: 'Key',
            textTempo: 'Tempo'
        },
        changePassword: {
            form: {
                currentPasswordLabel: 'Current password',
                newPasswordLabel: 'New password',
                submitBtn: 'Change password',
                validation: {
                    alerts: {
                        success: 'The password has been changed',
                        validationFail: 'There are errors in the form below',
                        userPasswordError1: 'The current password entered is incorrect',
                        userPasswordError2: 'Invalid password',
                        weakPassword: 'The password is too weak or common, please choose another new password',
                        firebaseError: 'Failed to change the password...',
                        generalError: 'Failed to change the password...'
                    }
                }
            }
        },
        card: {
            albumCoverImgAlt: 'Album Cover',
            playingLabel: 'Playing',
            keyText: 'Key:',
            composer: 'Composer:',
            backgroundTrackText: 'Backing Track:',
            backgroundTrackYesText: 'Yes'
        }
    },

    assetsComponents: {
        menuWithContent: {
            h3UserGreeting: 'Welcome',
            settingsBtn: 'Settings',

            libraryHeading: 'Library',
            evaluationHeading: 'Evaluation',

            homeRouteBtn: 'Home',
            musicRouteBtn: 'Music',
            soundscapesRouteBtn: 'Soundscapes',
            keysRouteBtn: 'Keys',
            libraryRouteBtn: 'Library',
            activateAccountRouteBtn: 'Activate Account',
            loginRouteBtn: 'Log In',

            evaluationRouteBtnPre: 'Before',
            evaluationRouteBtnAfter: 'After',
            evaluationRouteBtnFull: 'Full'
        },
        evaluationActiveModal: {
            dialogTitle: 'There is an ongoing evaluation',
            dialogContentText: 'What would you like to do?',
            newCheckinBtn: 'Start new check-in',
            continueCheckoutBtn: 'Continue with check-out'
        },
        evaluationTypeModal: {
            dialogTitle: 'How many emotions should be selectable?',
            dialogContentText: 'With 3 emotions, you choose by tapping a symbol. And with 5 emotions, you choose by sliding a slider.'
        },
        evaluationStageModal: {
            dialogTitle: 'What type of evaluation would you like to do?',
            dialogContentText: 'You can choose between simple (1 question) or expanded (multiple questions).'
        },
        evaluationBtn: {
            btnA: 'Start Evaluation',
            btnB: 'Continue Evaluation'
        }
    },

    home: {
        masterVolume: {
            paragraphMaster: 'Master volume'
        },
        instruments: {
            headingWaiting: 'Waiting for Funki instruments'
        },
        instrumentInformation: {
            paragraphSound: 'Sound',
            paragraphMusic: 'Music',
            paragraphSoundscape: 'Soundscape',
            paragraphKey: 'Key',
            paragraphChooseSound: 'Change arrangement',
            headingChooseSound: 'Choose Sound'
        },
        touchAlternateMode: {
            easyBtn: 'Easy',
            hardBtn: 'Hard'
        }
    },

    library: {
        libraryComponent: {
            searchTermMusic: 'Music',
            searchTermSoundscapes: 'Soundscapes',
            searchTermKeys: 'Keys',
            musicRouteBtn: 'Music',
            soundscapesRouteBtn: 'Soundscapes',
            keysRouteBtn: 'Key',
            searchbarPlaceholder: 'Search for %{displayedSearchTerm}',
            categoryAll: 'All'
        },
        displayedCards: {
            tableCellName: 'Name',
            tableCellProducer: 'Producer',
            tableCellKey: 'Key',
            tableCellScale: 'Scale'
        }
    },

    settings: {
        accountRouteBtn: 'Account',
        licenseRouteBtn: 'License',
        logoutBtn: 'Log out',
        aboutRouteBtn: 'About',
        adminRouteBtn: 'Admin',

        account: {
            headingEmail: 'Linked Email Address',
            headingPassword: 'Password',
            accordionPassword: 'Change Password',
            headingLicense: 'License Linked',
            headingNoLicense: 'No License Linked',
            bodyNoLicense: 'Your account is not linked to a license yet',
            connectLicenseRouteBtn: 'Link a License',
            changeLanguage: 'Language'
        },

        license: {
            headingOwner: 'License Owner',
            headingPaymentPlan: 'Payment Plan',
            headingConnectedInstruments: 'Your instruments',
            bodyConnectedInstruments: 'No instruments are linked',
            boxActive: 'Active',
            resetWifiPasswordBtn: 'Reset WiFi Password'
        }
    },

    evaluationTool: {
        evaluationStart: {
            startBtnBefore: 'START NEW CHECK-IN',
            startBtnAfter: 'START NEW CHECK-OUT',
            startBtnFull: 'START NEW EVALUATION',

            imgAltA: 'start',
            imgAltB: 'evaluation'
        },
        evaluationQuestion: {
            forwardBtn: 'CONTINUE',
            questionBeforeAfter: 'HOW ARE YOU?',
            questionsFull: {
                question1: 'HOW DID IT FEEL TO PLAY TODAY?',
                question2: 'HOW DO YOU FEEL?',
                question3: 'WOULD YOU LIKE TO PLAY AGAIN?'
            },
            answerBeforeAfter: {
                textContent1: 'BAD',
                textContent2: 'AVERAGE',
                textContent3: 'GOOD',
                imgAlt1: 'widget-bad',
                imgAlt2: 'widget-so-so',
                imgAlt3: 'widget-good',

                answersSlider: {
                    textContent1: 'TERRIBLE',
                    textContent2: 'BAD',
                    textContent3: 'OKAY',
                    textContent4: 'GOOD',
                    textContent5: 'GREAT',
                    imgAlt1: 'widget-terrible',
                    imgAlt2: 'widget-bad',
                    imgAlt3: 'widget-okay',
                    imgAlt4: 'widget-good',
                    imgAlt5: 'widget-great'
                }
            },
            answerFull: {
                answer1: {
                    textContent1: 'BAD',
                    textContent2: 'SO-SO',
                    textContent3: 'GOOD',
                    imgAlt1: 'smiley-bad',
                    imgAlt2: 'smiley-so-so',
                    imgAlt3: 'smiley-very-good'
                },
                answer2: {
                    textContent1: 'TIRED',
                    textContent2: 'SO-SO',
                    textContent3: 'ENERGETIC',
                    imgAlt1: 'smiley-tired',
                    imgAlt2: 'smiley-so-so',
                    imgAlt3: 'smiley-energetic'
                },
                answer3: {
                    textContent1: 'NO',
                    textContent2: 'MAYBE',
                    textContent3: 'YES',
                    imgAlt1: 'smiley-bad',
                    imgAlt2: 'smiley-so-so',
                    imgAlt3: 'smiley-very-good'
                }
            }
        },
        evaluationEnd: {
            h1: 'THANK YOU FOR YOUR RESPONSE',
            imgAltA: 'clear',
            btnTextFull: "NOW IT'S OVER, THANK YOU FOR TODAY",
            startBtn: 'START',
            backBtn: 'CHANGE RESPONSE'
        },
        endCurrentModal: {
            yesBtn: 'YES, EXIT',
            noBtn: 'NO, CONTINUE',
            h1: 'DO YOU WANT TO CANCEL CHECK-IN',
            confirmationTextContent: 'CHECK-IN CANCELED'
        },
        endModal: {
            yesBtn: 'YES',
            noBtn: 'NO',
            h1: 'DO YOU WANT TO EXIT AND SAVE ( %{answerCount} ) RESPONSES?',
            confirmationTextContent: 'THANKS! ( %{answerCount} ) ANSWERS WAS SAVED'
        },
        backForwardButtonBox: {
            endBtn: 'EXIT'
        }
    },

    logIn: {
        form: {
            emailLabel: 'Email Address',
            passwordLabel: 'Password',
            loginBtn: 'Log in',
            validation: {
                nonValidEmail: 'Invalid email address',
                promptEmail: 'Enter your email address',
                promptPassword: 'Enter your password',
                alerts: {
                    general: 'There are errors in the form below',
                    emailPassword: 'Invalid email address or password',
                    fail: 'Login failed...'
                }
            }
        },
        account: {
            forgotPasswordBtn: 'Forgot password?',
            registerAccountBtn: 'Create new account'
        }
    },

    requestPasswordReset: {
        heading: 'Forgot your password?',
        paragraph: "Enter your email address, and we'll send you a link so you can choose a new password.",
        backToLoginBtn: 'Back to Login',
        form: {
            continueBtn: 'Continue',
            emailLabel: 'Email Address',
            validation: {
                nonValidEmail: 'Invalid email address',
                promptEmail: 'Please enter your email address',
                continueBtn: 'Continue',
                alerts: {
                    success: "We have sent a link to %{email}. Click on the link and follow the instructions in the new window that opens. If you don't see the email, be sure to check your spam folder.",
                    error: 'There are errors in the form below'
                }
            }
        }
    },

    resetPassword: {
        heading: 'Choose your new password',
        backToLoginBtn: 'Back to Login',
        form: {
            newPasswordLabel: 'New Password',
            savePasswordBtn: 'Save Password',
            validation: {
                nonValidPassword: 'Must be at least 8 characters',
                alerts: {
                    expiredLink: `The password reset link has expired, please make a new request to reset the password`,
                    brokenLink: `The password reset link is either corrupted or has already been used, please make a new request to reset the password`,
                    success: 'The new password has been saved',
                    error: 'Failed to set new password',
                    general: 'There are errors in the form below'
                }
            }
        }
    },

    signUp: {
        backToLoginBtn: 'Back to Login',
        form: {
            nameLabel: 'Name (optional)',
            emailLabel: 'Email address',
            passwordLabel: 'Password',
            createAccountBtn: 'Create account',
            validation: {
                nonValidName: 'Max 50 characters long',
                nonValidEmail: 'Invalid email address',
                nonValidPassword: 'Must be at least 8 characters',
                required: 'Required',

                alerts: {
                    general: 'There are errors in the form below',
                    emailDuplicate: 'There is already an account linked to this email address',
                    passwordWeak: 'The password is too weak or common, please choose a different one',
                    success: 'User created',
                    fail: 'Failed to create user...'
                }
            }
        }
    },

    activateAccount: {
        heading: 'Your account is not linked to any license yet',
        paragraph: 'To activate your account and connect to a license, enter the activation code for the license below.',
        paragraphLoading: 'Loading',
        noActivationCodeBtn: "Don't have an activation code?",
        backToLoginBtn: 'Back to Login',
        form: {
            activateBtn: 'Activate',
            activationCodeLabel: 'Activation code',
            validation: {
                alerts: {
                    success: 'Activation was successful',
                    error: 'Something went wrong during activation, please try again or contact us at Funki if the issue persists',
                    nonValidCode: 'The provided activation code is invalid'
                }
            }
        }
    },

    loading: {
        paragraph: 'Loading...'
    },
    category: {
        all: 'All',
        instrument: 'Instrument',
        relax: 'Relaxation',
        electronic: 'Electronic',
        holiday: 'Holiday',
        religion: 'Religion',
        animal: 'Animals',
        seasons: 'Seasons',
        society: 'Society',
        humanbeing: 'The Human Being',
        nature: 'Nature',
        percussion: 'Percussion',
        student: 'Student',
        song: 'Song',
        activityconcept: 'Activity Concept',
        sport: 'Sport',
        transportation: 'Transportation',
        africa: 'Africa',
        south_america: 'South America',
        greenland: 'Greenland',
        australia: 'Australia',
        pop: 'Pop',
        rullen: 'Rullen',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
        A: 'A',
        B: 'B'
    },
    ota: {
        rebooting: 'Rebooting instrument...',
        rebootingFailed: 'Download was interrupted. Check the connection or restart the instrument.',
        noResponse: 'No response from the instrument.',
        rebootLoading: 'This may take a few seconds...',
        rebootBtnTitle: 'Restart now',
        btnCloseTitle: 'Close',
        dialogTitle: 'Updating instrument',
        inProgress: 'Update in progress, do not turn off the instrument',
        updatedSuccessful: 'Your instrument is up to date!',

        status: {
            idle: 'No update in progress',
            started: 'Update started...',
            connected: 'Connecting to server...',
            downloading: 'Downloading update...',
            inspecting: 'Inspecting firmware metadata...',
            verifying: 'Verifying firmware...',
            decrypting: 'Decrypting firmware...',
            updating: 'Writing firmware to memory...',
            complete: 'Update complete! Please restart your instrument',
            failed: 'Something went wrong during the update.',
            cancelled: 'The update was cancelled.',
            updated: 'Update successful!'
        },

        error: {
            battery: 'Battery level is too low to update. Please charge your instrument and try again.',
            busy: 'The instrument is already updating.',
            general: 'An unknown error occurred.',
            request: 'Invalid update request.',
            connection: 'Failed to connect to the server.',
            download: 'Download failed.',
            version: 'Invalid firmware version.',
            validation: 'Firmware validation failed.',
            rollback: 'Update failed during startup. Restoring previous version.'
        }
    },

    settingDialog: {
        heading: 'Settings',
        resetNetwork: 'Reset network',
        resetNetworkDescription: 'Select this to disconnect your instrument from its current network',
        firmwareVersion: 'Firmware version',
        noFirmwareInfo: 'Version information not available',
        firmwareUpToDate: 'The instrument has the latest firmware',
        downloadUpdateBtn: 'Download latest update',
        firmwareAvailable: 'A newer firmware version is available'
    }
}
